var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-conversation-answer-emoji",class:_vm.className,on:{"click":_vm.Handle_OnClick}},[_c('span',[_vm._v(_vm._s(_vm.multipleChoiceModel.shortText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }